var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMediaImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "16px",
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-media-images") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-library-V2",
    transform: "translate(-19.000000, -211.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 0.734693878
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-media-images",
    transform: "translate(20.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 17.6326531,
    height: 13.9591837
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 8.81632653 3.67346939 5.14285714 5.14285714 7.34693878 6.97959184 6.97959184 8.44897959 8.44897959 10.6530612 8.44897959 13.2244898 10.2857143 17.6377959 10.2857143"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.4081633,
    cy: 4.2244898,
    r: 1.28571429
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMediaImages);
export default __webpack_public_path__ + "static/media/icon-media-images.b89e96bcea5963d3fe2aa76ab775a072.svg";
export { ForwardRef as ReactComponent };